import React, { useMemo } from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import moment from 'moment';
import PropTypes from 'prop-types';

import { t, number } from '~/helpers';

import { WrapperTabela } from './styles';

export default function TablePitStopExtratoAreia({ rows }) {
  const formatEntradaSaida = (value) =>
    Number(value || 0) === 0 ? '' : number(value, 2);

  const headers = useMemo(
    () => [
      { label: t('s.relatorio.resumoturno.movimentacao'), align: 'left' },
      { label: t('s.operacao.turno.datahora'), align: 'center' },
      {
        label: t('s.cadastro.pitstop.nomeusuarioresponsavel'),
        align: 'center',
      },
      { label: t('s.relatorio.resumoturno.entrada'), align: 'center' },
      { label: t('s.relatorio.resumoturno.saida'), align: 'center' },
      { label: t('s.relatorio.extratoproduto.saldo'), align: 'center' },
    ],
    []
  );

  return (
    <WrapperTabela height="80vh">
      <TableContainer>
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead>
            <TableRow>
              {headers.map((header, index) => (
                <TableCell
                  align={header.align}
                  key={`cell-index-head-${index}`}
                >
                  {header.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow hover tabIndex={-1} key={`table-row-body-${index}`}>
                <TableCell key="table-cell-body-1">
                  {row.movimentacaopitstopextratoareia}
                </TableCell>
                <TableCell key="table-cell-body-2" align="center">
                  {row.datahorapitstopextratoareia
                    ? moment(row.datahorapitstopextratoareia).format(
                        'DD/MM/YYYY HH:mm:ss'
                      )
                    : ''}
                </TableCell>
                <TableCell key="table-cell-body-3">
                  {row.nomeusuariopitstopextratoareia}
                </TableCell>
                <TableCell key="table-cell-body-4" align="right">
                  {formatEntradaSaida(row.entradapitstopextratoareia)}
                </TableCell>
                <TableCell key="table-cell-body-5" align="right">
                  {formatEntradaSaida(row.saidapitstopextratoareia)}
                </TableCell>
                <TableCell key="table-cell-body-6" align="right">
                  {number(row.saldopitstopextratoareia || 0, 2)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </WrapperTabela>
  );
}

TablePitStopExtratoAreia.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
};
